<template>
  <section class="container-fluid exp-mt" v-if="upcomingEvents.length > 0">
    <div class="row component-container">
      <div class="col-lg-12 text-center d-flex flex-column justify-content-center">
        <a href="#main-destination" class="button skip">Skip Upcoming Events</a>
        <h2 class="">{{ upcomingEventsTitle }}</h2>
        <div v-html="upcomingEventsDescription"></div>
        <div>
        </div>
      </div>
      <div class="event-container row events col-lg-10">
        <div v-for="(event, index) in upcomingEvents.slice(0,6)" :key="index" class="col-lg-4">
         <router-link :to="'/upcoming-events/'+event.slug" class="card-experiences">
        <figure class="event-image">
          <b-img-lazy v-if="event.imageUrl" :src="event.imageUrl" class="img-fluid" />
          <img v-else src="/images/misc/event-no-image.png" class="img-fluid">
        </figure>
        <div class="card-content">
          <h3 class="event-name"> {{event.name}} </h3>
          <div v-if="event.startDate && event.startDate == event.endDate" class="d-flex">
            <div class="event-date">{{ convertToDate(event.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric'}) }}</div>
          </div>
          <div v-if="event.startDate && event.startDate !== event.endDate" class="d-flex">
            <div class="event-date">{{ convertToDate(event.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric'}) }}</div><div> — </div>
            <div class="event-date">{{ convertToDate(event.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric'}) }}</div>
          </div>
          <span class="event-location" itemscope itemtype="http://schema.org/Place">
            <img src="/images/events/map-north.svg" class="region-map" alt="" role="presentation" v-if="event.region == 'north-alabama'"/>
            <img src="/images/events/map-central.svg" class="region-map" alt="" role="presentation" v-if="event.region == 'central-alabama'"/>
            <img src="/images/events/map-south.svg" class="region-map" alt="" role="presentation" v-if="event.region == 'south-alabama'"/>
            <img src="/images/events/map-beach.svg" class="region-map" alt="" role="presentation" v-if="event.region == 'beaches-gulf-coast'"/>
            <div :class="[event.region + '-event-name']">
              {{ event.area }}<br/>
              <span class="city-name" itemprop="addressLocality">{{ event.city }}</span>
              <router-link :to="'/upcoming-events/'+event.slug" class="details-link">More Details »</router-link>
            </div>
          </span>
        </div>
        </router-link>
        </div>
      </div>
    </div>
    <router-link class="button" to="/festivals-and-events">View All Events</router-link>
  </section>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { convertToDate } from '../../../store/helpers/helpers';

@Component({
  data() {
    return {};
  },
  methods: {
    convertToDate,
  },
})
class ExperienceUpcomingEvents extends Vue {
    @Prop({
      type: [Array],
      required: true,
    })
    upcomingEvents;

    @Prop({ type: [String] })
    upcomingEventsTitle;

    @Prop({ type: [String] })
    upcomingEventsDescription;
}

export default ExperienceUpcomingEvents;
</script>

<style scoped lang="scss">
.event-image {
  align-items: center;
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 200px;
  overflow: hidden;
}

.ani-chevron {
  font-size: 16px;
}
.button {
    background: white;
    border: 2px solid #173945;
    color: #173945;
    padding: 15px 75px 10px 65px;
    transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #F2FAFC;
    box-shadow: 0 2px 27px 0 rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out; }

}
.component-container {
  align-items: center;
  display: flex;
  justify-content: center;
}
.card-experiences {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
    color: #173945;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;
    margin-right: auto;
    margin-left: auto;
    text-align: left;
    text-decoration: none;
    transition: all .3s ease-in-out;

  &:hover {
    box-shadow: 0 2px 27px 0 rgba(0, 0, 0, 0.2);
    text-decoration: none; }


}
.card-experiences a {
  color: #173945;
}
.card-content {
  display: flex;
  flex-direction: column;
  line-height: 20px;
  width: 100%;
  padding: 10px 16px 16px;
}
.city-name {
  font-family: 'IdealSans-Medium';
  font-size: 16px;
}
.details-link {
  float: right;
  font-size: 16px;
  position: relative;
  text-decoration: none;
}
.exp-mt {margin-top: 120px;}

.skip {
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    left: -999em;
    top:15px;
    z-index: 9999;
    opacity: 0;
    position: absolute!important;
    padding: 15px 25px 10px 25px!important;
}
.skip:focus {
    opacity: 1;
  left: 100px;
}
a.router-link-active:hover{
  color:#ffffff;
  text-decoration: underline;
}
.event-name {
  display: flex;
  flex-direction: column;
  font-family: 'klinicslabbold';
  font-size: 22px;
  height: 40px;
  justify-content: center;
}

.event-date {
  font-family: 'IdealSans-Medium';
  font-size: 16px;
}
.events{
  flex-wrap: wrap;
  margin-top: 50px;
}
span.icon-events-upcoming:before {
  content: "\e90b";
  color:black;
  font-size: 80px;
}
.event-location {
  display: block;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  margin-top: 12px;
}
.region-map {
  width:20px;
  float: left;
  margin:3px 8px 0 0;
}

@media only screen and (max-width: 1200px) {
  .events-hd {
    font-size:50px;
    line-height:54px;
  }
}
@media only screen and (max-width: 768px) {
  .card-experiences {
    width: 60%;
  }
}
@media only screen and (max-width: 414px) {
  .card-experiences {
    width: 100%;
  }
}
</style>
